import * as XMPP from 'stanza';
import { JXT } from 'stanza';
import { DataFormFieldType, MUCAffiliation, ChatState } from 'stanza/Constants';
export { ChatState } from 'stanza/Constants';
import { NS_DATAFORM, NS_DATAFORM_VALIDATION } from 'stanza/Namespaces';
import { childText, attribute, childBoolean, childIntegerAttribute, childEnum, childAttribute } from 'stanza/jxt';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var getMessage = function (xml) {
    var forwarded = xml.children.find(function (c) { return c.name === 'forwarded'; });
    var m = forwarded.children.find(function (c) { return c.name === 'message'; });
    var r = m.children.find(function (c) { return c.name === 'result'; });
    if (r) {
        return getMessage(r);
    }
    return m;
};
var ChatInbox = function (client, stanzas) {
    var namespace = 'erlang-solutions.com:xmpp:inbox:0';
    stanzas.define({
        namespace: namespace,
        element: 'inbox',
        path: 'iq.inbox',
        fields: {
            queryId: JXT.attribute('queryId'),
        },
    });
    stanzas.define({
        namespace: 'http://jabber.org/protocol/rsm',
        element: 'set',
        path: 'iq.inbox.set',
    });
    stanzas.define({
        namespace: '',
        element: 'max',
        path: 'iq.inbox.set.max',
        fields: {
            max: JXT.text('1'),
        },
    });
    /*   stanzas.define({
      namespace: '',
      element: 'after',
      path: 'iq.inbox.set.after',
      fields: {
        max: JXT.text('1'),
      },
    });
  
    stanzas.define({
      namespace: 'erlang-solutions.com:xmpp:inbox:0',
      element: 'fin',
      path: 'iq.fin',
      fields: {
        last: JXT.deepChildText([
          { element: 'set', namespace: 'http://jabber.org/protocol/rsm' },
          { element: 'last', namespace: '' },
        ]),
      },
    }); */
    stanzas.define({
        namespace: '',
        element: 'box',
        path: 'iq.box.value',
        fields: {
            value: JXT.text('value'),
        },
    });
    stanzas.define([
        {
            aliases: [{ path: 'iq.message.forms', multiple: true }],
            element: 'x',
            fields: {
                instructions: __assign(__assign({}, JXT.multipleChildText(null, 'instructions')), { exportOrder: 2 }),
                reported: __assign(__assign({}, JXT.splicePath(null, 'reported', 'dataformField', true)), { exportOrder: 3 }),
                title: __assign(__assign({}, childText(null, 'title')), { exportOrder: 1 }),
                type: attribute('type'),
            },
            namespace: NS_DATAFORM,
            optionalNamespaces: {
                xdv: NS_DATAFORM_VALIDATION,
            },
            path: 'iq.inbox.dataform',
        },
        {
            aliases: [
                { path: 'iq.inbox.dataform.fields', multiple: true },
                { path: 'iq.inbox.dataform.items.fields', multiple: true },
            ],
            element: 'field',
            fields: {
                description: childText(null, 'desc'),
                label: attribute('label'),
                name: attribute('var'),
                rawValues: __assign(__assign({}, JXT.multipleChildText(null, 'value')), { exporter: function () { return null; } }),
                required: childBoolean(null, 'required'),
                type: attribute('type'),
                value: {
                    importer: function (xml, context) {
                        var fieldType = xml.getAttribute('type');
                        var converter = JXT.multipleChildText(NS_DATAFORM, 'value');
                        var rawValues = converter.importer(xml, context);
                        var singleValue = rawValues[0];
                        switch (fieldType) {
                            case DataFormFieldType.TextMultiple:
                            case DataFormFieldType.ListMultiple:
                            case DataFormFieldType.JIDMultiple:
                                return rawValues;
                            case DataFormFieldType.Hidden:
                            case DataFormFieldType.Fixed:
                                if (rawValues.length === 1) {
                                    return singleValue;
                                }
                                return rawValues;
                            case DataFormFieldType.Boolean:
                                if (singleValue) {
                                    return singleValue === '1' || singleValue === 'true';
                                }
                                break;
                            default:
                                return singleValue;
                        }
                    },
                    exporter: function (xml, data, context) {
                        var converter = JXT.multipleChildText(null, 'value');
                        var outputData = [];
                        var rawData = context.data && context.data.rawValues ? context.data.rawValues[0] : undefined;
                        if (typeof data === 'boolean') {
                            if (rawData === 'true' || rawData === 'false') {
                                outputData = [rawData];
                            }
                            else {
                                outputData = [data ? '1' : '0'];
                            }
                        }
                        else if (!Array.isArray(data)) {
                            outputData = [data.toString()];
                        }
                        else {
                            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                                var value = data_1[_i];
                                outputData.push(value.toString());
                            }
                        }
                        converter.exporter(xml, outputData, Object.assign({}, context, {
                            namespace: NS_DATAFORM,
                        }));
                    },
                },
            },
            namespace: NS_DATAFORM,
            path: 'iq.inbox.dataformField',
        },
        {
            aliases: [{ path: 'iq.inbox.dataform.fields.options', multiple: true }],
            element: 'option',
            fields: {
                label: attribute('label'),
                value: childText(null, 'value'),
            },
            namespace: NS_DATAFORM,
        },
        {
            aliases: [{ path: 'iq.inbox.dataform.items', multiple: true }],
            element: 'item',
            namespace: NS_DATAFORM,
        },
        // ----------------------------------------------------------------
        // XEP-0122: Data Forms Validation
        // ----------------------------------------------------------------
        {
            element: 'validate',
            fields: {
                listMax: childIntegerAttribute(null, 'list-range', 'max'),
                listMin: childIntegerAttribute(null, 'list-range', 'min'),
                method: childEnum(null, ['basic', 'open', 'range', 'regex'], 'basic'),
                rangeMax: childAttribute(null, 'range', 'max'),
                rangeMin: childAttribute(null, 'range', 'min'),
                regex: childText(null, 'regex'),
                type: attribute('datatype', 'xs:string'),
            },
            namespace: NS_DATAFORM_VALIDATION,
            path: 'iq.inbox.dataform.fields.validation',
        },
    ]);
    stanzas.define({
        namespace: 'erlang-solutions.com:xmpp:inbox:0#conversation',
        element: 'query',
        path: 'iq.box',
        fields: {
            jid: JXT.attribute('jid'),
        },
    });
    stanzas.define({
        namespace: namespace,
        element: 'result',
        path: 'message.inbox',
        fields: {
            unread: JXT.attribute('unread'),
            body: {
                exporter: function (xml, data) { },
                importer: function (xml) {
                    var body = getMessage(xml).children.find(function (c) { return c.name === 'body'; });
                    return body.getText();
                },
            },
            date: {
                exporter: function (xml, data) { },
                importer: function (xml) {
                    var forwarded = xml.children.find(function (c) { return c.name === 'forwarded'; });
                    var delay = forwarded.children.find(function (c) { return c.name === 'delay'; });
                    return new Date(delay.getAttribute('stamp'));
                },
            },
            lastMessageId: {
                exporter: function (xml, data) { },
                importer: function (xml) {
                    return getMessage(xml).getAttribute('id');
                },
            },
            with: {
                exporter: function (xml, data) { },
                importer: function (xml) {
                    var message = getMessage(xml);
                    return XMPP.JID.toBare(XMPP.JID.toBare(message.getAttribute('to')) === XMPP.JID.toBare(client.jid)
                        ? message.getAttribute('from')
                        : message.getAttribute('to'));
                },
            },
            lastMessageSentBy: {
                exporter: function (xml, data) { },
                importer: function (xml) {
                    var message = getMessage(xml);
                    return message.getAttribute('from');
                },
            },
            subject: {
                exporter: function (xml, data) { },
                importer: function (xml) {
                    var _a;
                    return (_a = getMessage(xml).getChild('subject')) === null || _a === void 0 ? void 0 : _a.getText();
                },
            },
        },
    });
    client.inbox = function (max) {
        return client.sendIQ({
            type: 'set',
            inbox: {
                dataform: {
                    type: 'asdkek',
                    fields: [
                        {
                            type: 'list-single',
                            name: 'box',
                            value: 'inbox',
                            rawValues: ['inbox'],
                        },
                    ],
                },
                queryId: client.nextId(),
                set: max
                    ? {
                        max: max,
                    }
                    : null,
            },
        });
    };
};

var Status;
(function (Status) {
    Status["Online"] = "online";
    Status["Offline"] = "offline";
    Status["Busy"] = "busy";
    Status["PlayingMultiplayer"] = "playing-multiplayer";
    Status["Disconnected"] = "disconnected";
})(Status || (Status = {}));

var defaultUser = {
    id: '-1',
    isFriends: false,
    isTyping: false,
    isValidAge: true,
    jid: '-1@chat.hiber.world',
    pictureUrl: 'https://cdn.hibervr.com/static/images/profile-images/gray.png',
    status: Status.Online,
    username: 'hiber-user',
    dmEnabled: true,
    privacySettings: null,
    session: null,
    affiliation: 'none',
};

var namespace = 'jabber:iq:privacy';
var defineBlockList = function (stanzas) {
    stanzas.define({
        namespace: namespace,
        element: 'query',
        path: 'iq.query',
    });
    stanzas.define({
        namespace: namespace,
        element: 'list',
        path: 'iq.query.list',
        fields: {
            name: JXT.attribute('name'),
        },
    });
    stanzas.define({
        namespace: namespace,
        element: 'item',
        path: 'iq.query.list.item',
        fields: {
            type: JXT.attribute('type'),
            value: JXT.attribute('value'),
            action: JXT.attribute('action'),
            order: JXT.attribute('order'),
        },
    });
};
var BlockMucChat = function (client, stanzas) {
    defineBlockList(stanzas);
    client.BlockMucChat = function (jid) {
        return client.sendIQ({
            type: 'set',
            query: {
                namespace: namespace,
                list: {
                    name: 'urn:xmpp:muclight:0',
                    item: {
                        type: 'jid',
                        value: jid,
                        action: 'deny',
                        order: '1',
                    },
                },
            },
        });
    };
};
var getMucBlockedList = function (client, stanzas) {
    stanzas.define({
        namespace: namespace,
        element: 'query',
        path: 'iq.query',
    });
    stanzas.define({
        namespace: namespace,
        element: 'list',
        path: 'iq.query.list',
        fields: {
            name: JXT.attribute('name'),
        },
    });
    client.getMucBlockedList = function () {
        return client.sendIQ({
            type: 'get',
            from: client.jid,
            query: {
                namespace: namespace,
                list: {
                    name: 'urn:xmpp:muclight:0',
                },
            },
        });
    };
};
var UnblockMucChat = function (client, stanzas) {
    defineBlockList(stanzas);
    client.UnblockMucChat = function (jid) {
        return client.sendIQ({
            type: 'set',
            query: {
                namespace: namespace,
                list: {
                    name: 'urn:xmpp:muclight:0',
                    item: {
                        type: 'jid',
                        value: jid,
                        action: 'allow',
                        order: '1',
                    },
                },
            },
        });
    };
};

var ChatClient = /** @class */ (function () {
    function ChatClient(config) {
        var _this = this;
        this.remoteJID = 'chat.hiber.world';
        this.inbox = [];
        this.loadConversationsPromise = new Promise(function (resolve) {
            _this.conversationsPromiseResolveFunc = resolve;
        });
        this.showLogs = false;
        this.mutedJids = [];
        this.rosterJids = [];
        this.conversationUsers = [];
        this.roomInfos = new Map();
        this.connectionAttempts = 0;
        this.isConnected = false;
        this.isConnecting = true;
        this.conversations = new Map();
        this.loadingConversations = true;
        this.remoteRoomPart = "muclight.".concat(this.remoteJID);
        this.updateUserChatState = function (jid, userId, state) {
            var conversation = _this.findConversation(jid);
            if (!conversation) {
                return;
            }
            if (conversation.type === 'chat') {
                conversation.user.isTyping = state === ChatState.Composing;
            }
        };
        this.JID = "".concat(config.userId, "@").concat(this.remoteJID);
        this.token = config.token;
        this.chatDomain = config.chatDomain;
        this.apiUrl = config.apiUrl;
        if (typeof config.showLogs !== 'undefined') {
            this.showLogs = config.showLogs;
        }
        this.createClient();
        this.client.use(ChatInbox);
        this.client.use(BlockMucChat);
        this.client.use(getMucBlockedList);
        this.client.use(UnblockMucChat);
        this.setupListeners();
        this.connect();
    }
    ChatClient.prototype.logError = function (error) {
        if (this.showLogs) {
            console.error("[Chat Client Error]: ".concat(error));
        }
    };
    ChatClient.prototype.log = function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        if (this.showLogs) {
            console.log.apply(console, __spreadArray(['[Chat Client Log]: '], messages, false));
        }
    };
    ChatClient.prototype.createClient = function () {
        this.client = XMPP.createClient({
            jid: this.JID,
            password: this.token,
            server: 'chat.hiber.world',
            transports: {
                websocket: "".concat(this.chatDomain, "/ws-xmpp"),
            },
        });
    };
    ChatClient.prototype.fetchInbox = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.inbox(50)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.toBareJid = function (jid) {
        return XMPP.JID.toBare(jid);
    };
    ChatClient.prototype.jidFromGroupChatMessage = function (jid) {
        return XMPP.JID.parse(jid).resource;
    };
    ChatClient.prototype.destroy = function () {
        this.client.removeAllListeners();
        this.client.disconnect();
    };
    ChatClient.prototype.emitUpdateConversations = function () {
        this.client.emit('update:conversations', Array.from(this.conversations.values()));
    };
    ChatClient.prototype.addNewConversation = function (jid) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, user, conversation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = this.userIdFromJid(this.toBareJid(jid));
                        return [4 /*yield*/, this.fetchConversationUsers([userId])];
                    case 1:
                        user = (_a.sent())[0];
                        if ((user === null || user === void 0 ? void 0 : user.isFriends) && !this.hasConversation(jid)) {
                            conversation = this.createConversation(user);
                            this.addConversation(conversation);
                            return [2 /*return*/, conversation];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    ChatClient.prototype.setupListeners = function () {
        var _this = this;
        this.client.on('*', function (a) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            _this.log(a, rest);
        });
        this.client.on('auth:failed', function () {
            _this.logError("Auth failed with jid: ".concat(_this.JID, " and token: ").concat(_this.token));
        });
        this.client.on('message', function (m) {
            if (m.inbox) {
                _this.inbox.push(m.inbox);
                _this.rosterJids.push(m.inbox.with);
            }
        });
        this.client.on('groupchat', function (message) { return __awaiter(_this, void 0, void 0, function () {
            var bareJid, conversation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bareJid = this.toBareJid(message.from);
                        conversation = this.findConversation(bareJid);
                        if (!conversation) return [3 /*break*/, 2];
                        if (conversation.messages.some(function (m) { return m.id === message.id; })) {
                            return [2 /*return*/];
                        }
                        message.isMine = this.jidFromGroupChatMessage(message.from) === this.JID;
                        this.client.emit('message:received', { message: message, conversation: conversation });
                        return [4 /*yield*/, this.addMessageToConversation(bareJid, message)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        this.client.on('chat', function (message) { return __awaiter(_this, void 0, void 0, function () {
            var bareJid, conversation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bareJid = this.toBareJid(message.from);
                        return [4 /*yield*/, this.loadConversationsPromise];
                    case 1:
                        _a.sent();
                        if (!!this.hasConversation(bareJid)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.addNewConversation(bareJid)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        conversation = this.findConversation(bareJid);
                        if (!conversation) return [3 /*break*/, 5];
                        if (conversation.messages.some(function (m) { return m.id === message.id; })) {
                            return [2 /*return*/];
                        }
                        message.isMine = message.from === this.JID;
                        this.client.emit('message:received', { message: message, conversation: conversation });
                        return [4 /*yield*/, this.addMessageToConversation(bareJid, message)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); });
        this.client.on('presence', function (presence) {
            var conversation = _this.findConversation(presence.from);
            if (!conversation) {
                return;
            }
            if (conversation.type === 'chat') {
                conversation.user.status = presence.status === 'online' ? Status.Online : Status.Offline;
            }
            _this.emitUpdateConversations();
        });
        this.client.on('session:started', function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Ping the server every 10s to stay online
                        if (!this.client._keepAliveInterval) {
                            this.client.enableKeepAlive({
                                interval: 10,
                            });
                        }
                        this.connectionAttempts = 0;
                        this.client.sendPresence({ status: 'online' });
                        this.isConnected = true;
                        this.isConnecting = false;
                        this.status = Status.Online;
                        if (!this.loadingConversations) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchInbox()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadInitialConversations()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.emitUpdateConversations();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        this.client.on('disconnected', function () {
            _this.isConnected = false;
            _this.isConnecting = false;
            _this.status = Status.Disconnected;
            if (_this.connectionAttempts < 10) {
                setTimeout(function () {
                    if (!document.hidden && !_this.isConnecting && !_this.isConnected) {
                        _this.reConnect();
                        _this.connectionAttempts++;
                    }
                    else {
                        console.log('disconnected when browser tab is hidden, not reconnecting');
                    }
                }, _this.connectionAttempts === 0 ? 0 : 5000);
            }
            else {
                console.log('Connection to chat timed out.');
                _this.client.emit('chat:timeout');
            }
        });
        this.client.on('muc:invite', function (invite) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.loadingConversations) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadGroupChat(invite.room)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        this.client.on('message:sent', function (message) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!message.body || !message.updateAfterSent || message.type !== 'chat') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.addMessageToConversation(message.to, message)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.client.on('chat:state', function (state) {
            _this.updateUserChatState(state.from, _this.userIdFromJid(state.from), state.chatState);
            _this.emitUpdateConversations();
        });
        this.client.on('subscribe', function (e) { return __awaiter(_this, void 0, void 0, function () {
            var bareJid, shouldAccept, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bareJid = this.toBareJid(e.from);
                        return [4 /*yield*/, this.loadConversationsPromise];
                    case 1:
                        _a.sent();
                        shouldAccept = !!this.findConversation(bareJid);
                        if (!!shouldAccept) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchConversationUsers([this.userIdFromJid(bareJid)])];
                    case 2:
                        user = (_a.sent())[0];
                        shouldAccept = user && user.isFriends;
                        _a.label = 3;
                    case 3:
                        if (!shouldAccept) return [3 /*break*/, 5];
                        this.client.acceptSubscription(bareJid);
                        return [4 /*yield*/, this.addRosterItem(bareJid)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); });
        this.client.on('muc:available', function (message) { return __awaiter(_this, void 0, void 0, function () {
            var conversation, userIndex, newUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        conversation = this.findConversation(message.from);
                        if (!(conversation && message.muc.jid)) return [3 /*break*/, 4];
                        userIndex = conversation.users.findIndex(function (u) { return u.jid === message.muc.jid; });
                        if (!(userIndex !== -1)) return [3 /*break*/, 1];
                        conversation.users[userIndex].affiliation = message.muc.affiliation;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.fetchConversationUsers([this.userIdFromJid(message.muc.jid)], true)];
                    case 2:
                        newUser = (_a.sent())[0];
                        newUser.affiliation = message.muc.affiliation;
                        conversation.users.push(newUser);
                        _a.label = 3;
                    case 3:
                        this.emitUpdateConversations();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        this.client.on('muc:unavailable', function (presence) {
            var bareJid = _this.toBareJid(presence.from);
            if (presence.muc.jid === _this.JID) {
                // Case of the User leaver/kicked out of conversation, removing the coversation
                if (_this.conversations.has(bareJid)) {
                    _this.conversations.delete(bareJid);
                    _this.client.removeRosterItem(bareJid);
                }
                // Case of the non-leaving members in group to remove the leaving member
            }
            else {
                var conversation = _this.findConversation(presence.from);
                var userIndex = conversation.users.findIndex(function (u) { return u.jid === _this.toBareJid(presence.muc.jid); });
                conversation.users.splice(userIndex, 1);
                _this.conversations.set(bareJid, conversation);
            }
            _this.emitUpdateConversations();
        });
        this.client.on('muc:other', function (message) { return __awaiter(_this, void 0, void 0, function () {
            var newConfig, conversation;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(((_a = message.muc.statusCodes) === null || _a === void 0 ? void 0 : _a.includes('104')) && this.hasConversation(message.from))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getRoomConfig(message.from)];
                    case 1:
                        newConfig = _b.sent();
                        conversation = this.findConversation(message.from);
                        conversation.title = newConfig.roomName;
                        this.emitUpdateConversations();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        document.addEventListener('visibilitychange', function (e) {
            if (!_this.isConnected && document.visibilityState === 'visible') {
                console.log('reconnecting on focus');
                _this.reConnect();
            }
        });
    };
    ChatClient.prototype.loadGroupChat = function (jid) {
        return __awaiter(this, void 0, void 0, function () {
            var userIds, users, newConversation;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getUserIdsFromGroupChat(jid)];
                    case 1:
                        userIds = _b.sent();
                        return [4 /*yield*/, this.fetchConversationUsers(userIds, true)];
                    case 2:
                        users = _b.sent();
                        (_a = this.conversationUsers).push.apply(_a, users);
                        return [4 /*yield*/, this.getGroupChatConversation(users, {
                                with: jid,
                                body: '',
                                date: new Date(),
                                unread: '0',
                                lastMessageSentBy: jid,
                                lastMessageId: this.client.nextId(),
                                subject: '',
                            })];
                    case 3:
                        newConversation = _b.sent();
                        this.addConversation(newConversation);
                        return [2 /*return*/, newConversation];
                }
            });
        });
    };
    ChatClient.prototype.addConversation = function (conversation) {
        this.conversations.set(conversation.jid, conversation);
        this.emitUpdateConversations();
    };
    ChatClient.prototype.hasConversation = function (jid) {
        return !!this.findConversation(jid);
    };
    ChatClient.prototype.createConversation = function (user) {
        var jid = this.jidify(parseInt(user.id, 10));
        var conversation = {
            jid: jid,
            loadingMessages: true,
            messages: [],
            type: 'chat',
            unreadMessages: 0,
            user: __assign({ isTyping: false, jid: jid, status: Status.Online, isFriends: true, dmEnabled: true, isValidAge: true }, user),
            users: [],
            latestMessage: null,
            paging: {},
            draft: '',
            isMuted: false,
        };
        return conversation;
    };
    ChatClient.prototype.updateDraft = function (text, jid) {
        var conversation = this.findConversation(jid);
        if (!conversation) {
            return;
        }
        conversation.draft = text;
        this.emitUpdateConversations();
    };
    ChatClient.prototype.isJid = function (value) {
        var regex = new RegExp("\\d@".concat(this.remoteJID));
        return regex.test(value.toString());
    };
    ChatClient.prototype.jidify = function (value) {
        if (this.isJid(value)) {
            return this.toBareJid(value);
        }
        return "".concat(value, "@").concat(this.remoteJID);
    };
    ChatClient.prototype.jidifyMuc = function (value) {
        if (this.isJid(value)) {
            return this.toBareJid(value);
        }
        return "".concat(value, "@muclight.").concat(this.remoteJID);
    };
    ChatClient.prototype.connect = function () {
        this.client.connect();
    };
    ChatClient.prototype.reConnect = function () {
        this.connect();
        this.isConnecting = true;
    };
    ChatClient.prototype.disconnect = function () {
        this.client.disconnect();
    };
    ChatClient.prototype.addListener = function (eventName, callback) {
        this.client.on(eventName, callback);
    };
    ChatClient.prototype.removeListener = function (eventName, callback) {
        this.client.removeListener(eventName, callback);
    };
    ChatClient.prototype.createMessage = function (to, body, type) {
        if (type === void 0) { type = 'chat'; }
        var message = {
            createdAt: new Date(),
            from: this.JID,
            to: to,
            body: body,
            isMine: true,
            type: type,
            id: this.client.nextId(),
        };
        return message;
    };
    ChatClient.prototype.addMessageToConversation = function (jid, message) {
        return __awaiter(this, void 0, void 0, function () {
            var conversation;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.loadConversationsPromise];
                    case 1:
                        _b.sent();
                        conversation = this.findConversation(jid);
                        if (!conversation) {
                            return [2 /*return*/];
                        }
                        message.createdAt = ((_a = message.delay) === null || _a === void 0 ? void 0 : _a.timestamp) || message.createdAt || new Date();
                        if (conversation.type === 'groupchat') {
                            message.sender = conversation.users.find(function (u) { return u.jid === _this.jidFromGroupChatMessage(message.from); });
                        }
                        conversation.latestMessage = message;
                        if (!conversation.latestMessage.isMine && !this.isMuted(jid)) {
                            conversation.unreadMessages++;
                        }
                        conversation.messages.push(message);
                        this.emitUpdateConversations();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.findConversation = function (jid) {
        return this.conversations.get(this.toBareJid(jid));
    };
    ChatClient.prototype.removeMemberFromRoom = function (roomJid, jid) {
        return __awaiter(this, void 0, void 0, function () {
            var conversation, me, user;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        conversation = this.findConversation(roomJid);
                        me = conversation.users.find(function (u) { return u.jid === _this.JID; });
                        user = conversation.users.find(function (u) { return u.jid === jid; });
                        return [4 /*yield*/, this.client.setRoomAffiliation(roomJid, jid, MUCAffiliation.None, 'removed')];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sendInfoMessage("".concat(me.username, " removed ").concat(user.username, " from the group"), roomJid, 'groupchat')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.changeRoomMemberAffiliation = function (roomJid, jid, affiliation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.client.setRoomAffiliation(roomJid, jid, affiliation);
                return [2 /*return*/];
            });
        });
    };
    ChatClient.prototype.addMemberToRoom = function (roomJid, jid, affiliation, username) {
        return __awaiter(this, void 0, void 0, function () {
            var conversation, me;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.setRoomAffiliation(roomJid, jid, affiliation, 'invited')];
                    case 1:
                        _a.sent();
                        conversation = this.findConversation(roomJid);
                        me = conversation.users.find(function (u) { return u.jid === _this.JID; });
                        return [4 /*yield*/, this.sendInfoMessage("".concat(me.username, " invited ").concat(username), roomJid, 'groupchat')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.createRoom = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var roomJid;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (config.userJids.length === 0) {
                            return [2 /*return*/, null];
                        }
                        roomJid = config.jid || "".concat(this.client.nextId(), "@muclight.").concat(this.remoteJID);
                        return [4 /*yield*/, this.client.joinRoom(roomJid, 'me', {
                                muc: {
                                    affiliation: MUCAffiliation.Owner,
                                    type: 'info',
                                    role: 'moderator',
                                },
                            })];
                    case 1:
                        _a.sent();
                        if (!config.roomName) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.setRoomConfig(roomJid, 'roomname', config.roomName)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, Promise.all(config.userJids.map(function (jid) {
                            return _this.client.setRoomAffiliation(roomJid, jid, MUCAffiliation.Member);
                        }))];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.sendInfoMessage("Room created", roomJid, 'groupchat')];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, this.loadGroupChat(roomJid)];
                }
            });
        });
    };
    ChatClient.prototype.setRoomConfig = function (roomJid, label, value) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.configureRoom(roomJid, {
                            fields: [{ label: label, name: label, value: value, type: 'text-single' }],
                        })];
                    case 1:
                        _a.sent();
                        if (this.hasConversation(roomJid)) {
                            user = this.findConversation(roomJid).users.find(function (u) { return u.affiliation === 'owner'; });
                            this.sendInfoMessage("".concat(user.username, " changed group name to \"").concat(value, "\""), roomJid, 'groupchat');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.changeRoomOwner = function (roomJid, newOwner) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendInfoMessage("".concat(newOwner.username, " is the new Admin"), roomJid, 'groupchat')];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.client.setRoomAffiliation(roomJid, newOwner.jid, MUCAffiliation.Owner)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.leaveRoom = function (roomJid) {
        return __awaiter(this, void 0, void 0, function () {
            var conversation, meIndex, me, newOwner;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.client.removeRosterItem(roomJid);
                        conversation = this.findConversation(roomJid);
                        meIndex = conversation.users.findIndex(function (u) { return u.jid === _this.JID; });
                        me = conversation.users.splice(meIndex, 1)[0];
                        if (!(me.affiliation === MUCAffiliation.Owner && conversation.users.length !== 0)) return [3 /*break*/, 2];
                        newOwner = conversation.users[0];
                        return [4 /*yield*/, this.changeRoomOwner(roomJid, newOwner)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(conversation.users.length !== 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.sendInfoMessage("".concat(me.username, " left the group"), roomJid, 'groupchat')];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.client.setRoomAffiliation(roomJid, this.JID, MUCAffiliation.None)];
                    case 5:
                        _a.sent();
                        this.emitUpdateConversations();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.destroyRoom = function (roomJid) {
        this.client.destroyRoom(roomJid);
    };
    ChatClient.prototype.getRoomConfig = function (roomJid) {
        return __awaiter(this, void 0, void 0, function () {
            var cfg, obj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getRoomConfig(roomJid)];
                    case 1:
                        cfg = _a.sent();
                        obj = {
                            roomName: cfg.fields.find(function (field) { return field.name === 'roomname'; }).value,
                            subject: cfg.fields.find(function (field) { return field.name === 'subject'; }).value,
                        };
                        return [2 /*return*/, obj];
                }
            });
        });
    };
    ChatClient.prototype.getUnreadMessagesFrom = function (jid) {
        var _this = this;
        var _a;
        var numberOfUnreadMessages = ((_a = this.inbox.find(function (m) {
            return _this.toBareJid(m.with) === jid;
        })) === null || _a === void 0 ? void 0 : _a.unread) || '0';
        return parseInt(numberOfUnreadMessages, 10);
    };
    ChatClient.prototype.markAsRead = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var conversationJid, conversation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.client.markDisplayed(message);
                        conversationJid = message.from;
                        if (message.isMine) {
                            conversationJid = message.to;
                        }
                        return [4 /*yield*/, this.loadConversationsPromise];
                    case 1:
                        _a.sent();
                        conversation = this.findConversation(conversationJid);
                        if (conversation) {
                            conversation.unreadMessages = 0;
                        }
                        this.emitUpdateConversations();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.addRosterItem = function (jid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.updateRosterItem({
                            jid: jid,
                            subscription: 'both',
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.sendMessage = function (message, to, type, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.rosterJids.includes(to) && type !== 'groupchat')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.addRosterItem(to)];
                    case 1:
                        _a.sent();
                        this.client.subscribe(to);
                        this.rosterJids.push(to);
                        _a.label = 2;
                    case 2:
                        this.client.sendMessage({
                            to: to,
                            body: message,
                            type: type,
                            from: this.JID,
                            createdAt: new Date(),
                            chatState: ChatState.Active,
                            isMine: true,
                            updateAfterSent: options === null || options === void 0 ? void 0 : options.updateAfterSent,
                            id: options.id || this.client.nextId(),
                            marker: {
                                type: 'markable',
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.sendInfoMessage = function (message, to, type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.client.sendMessage({
                    to: to,
                    body: message,
                    type: type,
                    from: this.JID,
                    createdAt: new Date(),
                    isMine: true,
                    updateAfterSent: true,
                    subject: 'info',
                    marker: {
                        type: 'markable',
                    },
                });
                return [2 /*return*/];
            });
        });
    };
    ChatClient.prototype.getLatestMessageFromConversation = function (from) {
        return __awaiter(this, void 0, void 0, function () {
            var history;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getConversationHistory(from, '', 1)];
                    case 1:
                        history = _a.sent();
                        return [2 /*return*/, history[history.messages.length - 1]];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ChatClient.prototype.apiRequest = function (query_1) {
        return __awaiter(this, arguments, void 0, function (query, variables) {
            var response, json;
            if (variables === void 0) { variables = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(this.apiUrl, "/gql"), {
                            method: 'POST',
                            headers: {
                                'Content-type': 'Application/json',
                                authorization: this.token,
                            },
                            body: JSON.stringify({
                                query: query,
                                variables: variables,
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json];
                }
            });
        });
    };
    ChatClient.prototype.fetchMutedJids = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, json;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        query = "query mutedChatsList {\n      mutedChatsList {\n        id\n        chatId\n      }\n    }";
                        return [4 /*yield*/, this.apiRequest(query)];
                    case 1:
                        json = _b.sent();
                        if (!((_a = json.data) === null || _a === void 0 ? void 0 : _a.mutedChatsList)) {
                            return [2 /*return*/, []];
                        }
                        return [2 /*return*/, json.data.mutedChatsList.map(function (m) { return m.chatId; })];
                }
            });
        });
    };
    ChatClient.prototype.fetchConversationUsers = function (ids_1) {
        return __awaiter(this, arguments, void 0, function (ids, includeBlocked) {
            var query, json, users;
            var _this = this;
            var _a;
            if (includeBlocked === void 0) { includeBlocked = false; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        query = "query usersByIds($ids: [ID!]!, $includeBlocked: Boolean) {\n      usersByIds(ids: $ids, includeBlocked: $includeBlocked) {\n        id\n        username\n        isFriends\n        haveIBlocked\n        haveISentFriendRequest\n        haveIReceivedFriendRequest\n        pictureUrl\n        isValidAge\n        privacySettings {\n          id\n          directMessagingPublicity\n        }\n        session {\n          id\n          sessionStatus\n          actionStatus\n        }\n      }\n    }";
                        return [4 /*yield*/, this.apiRequest(query, { ids: ids, includeBlocked: includeBlocked })];
                    case 1:
                        json = _b.sent();
                        if (!((_a = json.data) === null || _a === void 0 ? void 0 : _a.usersByIds)) {
                            return [2 /*return*/, []];
                        }
                        users = json.data.usersByIds.map(function (u) {
                            var _a, _b;
                            var dmFriends = 1;
                            var dmPublic = 2;
                            var jid = _this.jidify(u.id);
                            var status = _this.getUserStatusFromSession(u.session);
                            var dmEnabled = ((_a = u.privacySettings) === null || _a === void 0 ? void 0 : _a.directMessagingPublicity) === dmFriends ||
                                ((_b = u.privacySettings) === null || _b === void 0 ? void 0 : _b.directMessagingPublicity) === dmPublic;
                            return __assign(__assign({}, u), { jid: jid, status: status, dmEnabled: dmEnabled });
                        });
                        return [2 /*return*/, users || []];
                }
            });
        });
    };
    ChatClient.prototype.userIdFromJid = function (jid) {
        return parseInt(jid.split('@')[0], 10);
    };
    ChatClient.prototype.sendChatState = function (to, state) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.client.sendMessage({
                    to: to,
                    chatState: state,
                    createdAt: new Date(),
                    isMine: true,
                    type: 'chat',
                });
                return [2 /*return*/];
            });
        });
    };
    ChatClient.prototype.getRoomInformation = function (jid) {
        return __awaiter(this, void 0, void 0, function () {
            var roomConfig, members, info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.roomInfos.has(jid)) {
                            return [2 /*return*/, this.roomInfos.get(jid)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 6]);
                        return [4 /*yield*/, this.getRoomConfig(jid)];
                    case 2:
                        roomConfig = _a.sent();
                        return [4 /*yield*/, this.client.getRoomMembers(jid)];
                    case 3:
                        members = _a.sent();
                        info = {
                            members: members.muc.users,
                            config: roomConfig,
                        };
                        this.roomInfos.set(jid, info);
                        return [2 /*return*/, info];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.client.sendIQ({
                                type: 'set',
                                box: {
                                    jid: jid,
                                    value: {
                                        value: 'archive',
                                    },
                                },
                            })];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, null];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.getUserStatusFromSession = function (session) {
        return (session === null || session === void 0 ? void 0 : session.sessionStatus) === 'ONLINE' ? Status.Online : Status.Offline;
    };
    ChatClient.prototype.getGroupChatConversation = function (users, conversation) {
        return __awaiter(this, void 0, void 0, function () {
            var roomInfo, roomUsers, lastMessage;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoomInformation(conversation.with)];
                    case 1:
                        roomInfo = _a.sent();
                        if (!roomInfo) {
                            return [2 /*return*/, null];
                        }
                        roomUsers = roomInfo.members.map(function (member) {
                            var roomUser = users.find(function (u) { return _this.jidify(u.id) === member.jid; });
                            if (!roomUser) {
                                return defaultUser;
                            }
                            roomUser.affiliation = member.affiliation;
                            return __assign({}, roomUser);
                        });
                        if (roomUsers.length === 0) {
                            return [2 /*return*/, null];
                        }
                        lastMessage = {
                            createdAt: conversation.date,
                            isMine: this.jidFromGroupChatMessage(conversation.lastMessageSentBy) === this.JID,
                            body: conversation.body,
                            sender: users.find(function (u) { return _this.jidify(u.id) === _this.jidFromGroupChatMessage(conversation.lastMessageSentBy); }),
                            from: conversation.with,
                            id: conversation.lastMessageId,
                            subject: conversation.subject,
                            marker: {
                                type: 'markable',
                            },
                        };
                        return [2 /*return*/, {
                                jid: this.toBareJid(conversation.with),
                                latestMessage: lastMessage,
                                messages: [lastMessage],
                                paging: null,
                                unreadMessages: this.getUnreadMessagesFrom(conversation.with),
                                type: 'groupchat',
                                title: roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.config.roomName,
                                subject: roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.config.subject,
                                user: null,
                                users: roomUsers,
                                loadingMessages: false,
                                draft: null,
                                isMuted: this.isMuted(conversation.with),
                            }];
                }
            });
        });
    };
    ChatClient.prototype.getRegularChatConversation = function (users, conversation) {
        return __awaiter(this, void 0, void 0, function () {
            var user, lastMessage;
            var _this = this;
            return __generator(this, function (_a) {
                user = users.find(function (user) { return parseInt(user.id) === _this.userIdFromJid(conversation.with); });
                if (!user) {
                    return [2 /*return*/, null];
                }
                lastMessage = {
                    createdAt: conversation.date,
                    isMine: this.toBareJid(conversation.lastMessageSentBy) === this.JID,
                    body: conversation.body,
                    from: conversation.with,
                    id: conversation.lastMessageId,
                    subject: conversation.subject,
                    marker: {
                        type: 'markable',
                    },
                };
                return [2 /*return*/, {
                        jid: this.toBareJid(conversation.with),
                        latestMessage: lastMessage,
                        messages: [lastMessage],
                        paging: null,
                        unreadMessages: this.getUnreadMessagesFrom(conversation.with),
                        type: 'chat',
                        title: null,
                        subject: null,
                        user: user,
                        users: [],
                        loadingMessages: false,
                        draft: null,
                        isMuted: this.isMuted(conversation.with),
                    }];
            });
        });
    };
    ChatClient.prototype.getUserIdsFromGroupChat = function (jid) {
        return __awaiter(this, void 0, void 0, function () {
            var userIds, room;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userIds = [];
                        return [4 /*yield*/, this.getRoomInformation(jid)];
                    case 1:
                        room = _a.sent();
                        if (!room) {
                            return [2 /*return*/, []];
                        }
                        room.members.map(function (m) {
                            if (!userIds.includes(_this.userIdFromJid(m.jid))) {
                                userIds.push(_this.userIdFromJid(m.jid));
                            }
                        });
                        return [2 /*return*/, userIds];
                }
            });
        });
    };
    ChatClient.prototype.blockRoom = function (jid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.blockedRooms.privacy.lists[0].items) {
                    this.blockedRooms.privacy.lists[0] = { items: [] };
                }
                this.blockedRooms.privacy.lists[0].items.push({ value: jid, action: 'deny', order: '-1', type: 'jid' });
                this.emitUpdateConversations();
                return [2 /*return*/, this.client.BlockMucChat(jid)];
            });
        });
    };
    ChatClient.prototype.unblockRoom = function (jid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.blockedRooms.privacy.lists.forEach(function (list) {
                    list.items.forEach(function (item, index, self) {
                        if (item.value === jid && item.action === 'deny') {
                            self.splice(index, 1);
                        }
                    });
                });
                this.emitUpdateConversations();
                return [2 /*return*/, this.client.UnblockMucChat(jid)];
            });
        });
    };
    ChatClient.prototype.isBlockedRoom = function (jid) {
        return this.blockedRooms.privacy.lists.some(function (list) { var _a; return (_a = list.items) === null || _a === void 0 ? void 0 : _a.some(function (item) { return item.value === jid && item.action === 'deny'; }); });
    };
    ChatClient.prototype.loadConversations = function (inboxes) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, userIds, groupConversation, groupIds, groupUsers, users;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.fetchMutedJids()];
                    case 1:
                        _a.mutedJids = _b.sent();
                        userIds = inboxes.map(function (c) { return _this.userIdFromJid(c.with); }).filter(function (id) { return !isNaN(id); });
                        groupConversation = inboxes.filter(function (r) { return r.with.includes('muclight'); });
                        groupIds = [];
                        return [4 /*yield*/, Promise.all(groupConversation.map(function (c) { return __awaiter(_this, void 0, void 0, function () {
                                var ids;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.getUserIdsFromGroupChat(c.with)];
                                        case 1:
                                            ids = _a.sent();
                                            groupIds.push.apply(groupIds, ids);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.fetchConversationUsers(groupIds, true)];
                    case 3:
                        groupUsers = _b.sent();
                        return [4 /*yield*/, this.fetchConversationUsers(userIds)];
                    case 4:
                        users = _b.sent();
                        this.conversationUsers = __spreadArray(__spreadArray([], users, true), groupUsers, true);
                        return [4 /*yield*/, Promise.all(inboxes.map(function (conversation) { return __awaiter(_this, void 0, void 0, function () {
                                var type, res, res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            type = conversation.with.includes('muclight') ? 'groupchat' : 'chat';
                                            if (!(type === 'groupchat')) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.getGroupChatConversation(groupUsers, conversation)];
                                        case 1:
                                            res = _a.sent();
                                            if (res) {
                                                this.conversations.set(conversation.with, res);
                                            }
                                            return [3 /*break*/, 4];
                                        case 2: return [4 /*yield*/, this.getRegularChatConversation(users.filter(function (user) { return user.isFriends; }), conversation)];
                                        case 3:
                                            res = _a.sent();
                                            if (res) {
                                                this.conversations.set(conversation.with, res);
                                            }
                                            _a.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 5:
                        _b.sent();
                        this.inbox = [];
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.loadInitialConversations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.client.getMucBlockedList()];
                    case 1:
                        _a.blockedRooms = (_b.sent()) || { privacy: { lists: [] } };
                        if (this.inbox.length === 0) {
                            this.setLoadingInitialDone();
                            return [2 /*return*/];
                        }
                        this.conversations.clear();
                        return [4 /*yield*/, this.loadConversations(this.inbox)];
                    case 2:
                        _b.sent();
                        this.setLoadingInitialDone();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.setLoadingInitialDone = function () {
        this.loadingConversations = false;
        this.conversationsPromiseResolveFunc(true);
        this.client.emit('initial:state:loaded', Array.from(this.conversations.values()));
        this.emitUpdateConversations();
    };
    ChatClient.prototype.loadMoreConversationHistory = function (to_1) {
        return __awaiter(this, arguments, void 0, function (to, before, max) {
            var conversation, history;
            var _a;
            var _b;
            if (before === void 0) { before = ''; }
            if (max === void 0) { max = 20; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        conversation = this.findConversation(to);
                        if (!conversation) {
                            return [2 /*return*/];
                        }
                        if (conversation.messages.length >= ((_b = conversation.paging) === null || _b === void 0 ? void 0 : _b.count)) {
                            return [2 /*return*/];
                        }
                        conversation.loadingMessages = true;
                        this.emitUpdateConversations();
                        return [4 /*yield*/, this.getConversationHistory(to, before, max)];
                    case 1:
                        history = _c.sent();
                        (_a = conversation.messages).unshift.apply(_a, history.messages);
                        conversation.paging = __assign(__assign({}, conversation.paging), history.paging);
                        conversation.loadingMessages = false;
                        this.emitUpdateConversations();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.groupMessages = function (messages, maxTimeBetween, forceNewGroupAfter) {
        var res = [];
        for (var i = 0; i < messages.length; i++) {
            var message = messages[i];
            var messagesInGroup = [message];
            var startTime = new Date(message.createdAt).getTime();
            var prevMessageTime = startTime;
            for (var j = i; j < messages.length - 1; j++) {
                var m = messages[j];
                var subMessageTime = new Date(m.createdAt).getTime();
                var delta = subMessageTime - prevMessageTime;
                if (!!forceNewGroupAfter && subMessageTime - startTime > forceNewGroupAfter) {
                    break;
                }
                if (delta < maxTimeBetween) {
                    messagesInGroup.push(m);
                }
                else {
                    break;
                }
                prevMessageTime = subMessageTime;
            }
            i += messagesInGroup.length - 1;
            res.push({
                timeStamp: startTime,
                messagesInGroup: messagesInGroup,
                haveUnreadInGroup: false,
            });
        }
        return res;
    };
    ChatClient.prototype.findConversationUser = function (jid) {
        return this.conversationUsers.find(function (u) { return u.jid === jid; }) || defaultUser;
    };
    ChatClient.prototype.getConversationHistory = function (to_1) {
        return __awaiter(this, arguments, void 0, function (to, before, max) {
            var conversation, messages, uniqueMessages;
            var _this = this;
            if (before === void 0) { before = ''; }
            if (max === void 0) { max = 20; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        conversation = this.findConversation(to);
                        return [4 /*yield*/, this.client.searchHistory({
                                with: to,
                                type: 'query',
                                paging: {
                                    before: before,
                                    max: max,
                                },
                            })];
                    case 1:
                        messages = _a.sent();
                        uniqueMessages = messages.results.filter(function (res) { return !(conversation === null || conversation === void 0 ? void 0 : conversation.messages.find(function (m) { return m.id === res.item.message.id; })); });
                        return [2 /*return*/, {
                                paging: messages.paging,
                                messages: uniqueMessages.map(function (m) {
                                    var from = m.item.message.from;
                                    var isGroupChat = from.includes('muclight');
                                    return __assign(__assign({}, m.item.message), { sender: _this.findConversationUser(_this.jidFromGroupChatMessage(from)), createdAt: m.item.delay.timestamp, isMine: isGroupChat ? _this.jidFromGroupChatMessage(from) === _this.JID : _this.toBareJid(from) === _this.JID });
                                }),
                            }];
                }
            });
        });
    };
    ChatClient.prototype.block = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var jid, conversation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jid = this.jidify(value);
                        return [4 /*yield*/, this.client.block(jid)];
                    case 1:
                        _a.sent();
                        conversation = this.conversations.get(jid);
                        if (conversation) {
                            this.conversations.delete(jid);
                        }
                        this.updateUser(jid, { haveIBlocked: true });
                        this.emitUpdateConversations();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.unblock = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var jid, history, conversation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jid = this.jidify(value);
                        return [4 /*yield*/, this.client.unblock(jid)];
                    case 1:
                        _a.sent();
                        this.updateUser(jid, { haveIBlocked: false });
                        return [4 /*yield*/, this.getConversationHistory(jid)];
                    case 2:
                        history = _a.sent();
                        if (history.messages.length === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.addNewConversation(jid)];
                    case 3:
                        conversation = _a.sent();
                        if (!conversation) {
                            return [2 /*return*/];
                        }
                        conversation.messages = history.messages;
                        conversation.paging = history.paging;
                        conversation.latestMessage = history.messages[history.messages.length - 1];
                        this.emitUpdateConversations();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.mute = function (jid) {
        this.mutedJids.push(jid);
        var conversation = this.findConversation(jid);
        if (conversation) {
            conversation.isMuted = true;
            this.emitUpdateConversations();
        }
    };
    ChatClient.prototype.unmute = function (jid) {
        var index = this.mutedJids.indexOf(jid);
        this.mutedJids.splice(index, 1);
        var conversation = this.findConversation(jid);
        if (conversation) {
            conversation.isMuted = false;
            this.emitUpdateConversations();
        }
    };
    ChatClient.prototype.isMuted = function (jid) {
        return this.mutedJids.includes(jid);
    };
    ChatClient.prototype.addErrorToMessage = function (jid, messageId, error) {
        return __awaiter(this, void 0, void 0, function () {
            var conversation, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadConversationsPromise];
                    case 1:
                        _a.sent();
                        conversation = this.findConversation(jid);
                        if (conversation) {
                            message = conversation.messages.find(function (message) { return message.id === messageId; });
                            if (message) {
                                message.err = error;
                                this.emitUpdateConversations();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatClient.prototype.isRoomOwner = function (conversation) {
        var _this = this;
        return conversation.users.find(function (u) { return u.jid === _this.JID; }).affiliation === MUCAffiliation.Owner;
    };
    ChatClient.prototype.updateUser = function (jid, user) {
        var _this = this;
        this.conversations.forEach(function (c) {
            var _a;
            var index = (_a = c.users) === null || _a === void 0 ? void 0 : _a.findIndex(function (u) { return u.jid === jid; });
            if (index !== -1) {
                c.users[index] = __assign(__assign({}, c.users[index]), user);
                _this.conversations.set(c.jid, c);
            }
        });
        var conversation = this.conversations.get(jid);
        if (conversation) {
            conversation.user = __assign(__assign({}, conversation.user), user);
            this.conversations.set(jid, conversation);
        }
        this.emitUpdateConversations();
    };
    return ChatClient;
}());

export { ChatClient, Status };
